import React, { useState, useRef } from "react";
import ContactList from "../component/contacts/contactList";
import * as contactsAction from "../../../redux/actions/contactsAction";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { API_STATUS, PAGE_SIZE } from "../../../constant/constant";
import {
  ACCESS_DENIED,
  ADMIN_ADD_CONTACTS,
  ADMIN_CONTACTS,
  ADMIN_EDIT_CONTACT,
  ADMIN_VIEW_CONTACT,
} from "../../../constant/routeContant";
import { useNavigate } from "react-router-dom";
import { checkPrivileges } from "../../../utils/rolesHelper";
import { toast, ToastContainer } from "react-toastify";
import { InactiveClient } from "../../../utils/helper";
import * as userAction from "../../../redux/actions/userAction";
import Loader from "../../../library/common/Loader";
import { getPreviousRoute } from "../../../utils/routeTracker";

export default function ContactsContainer() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const selectedServiceTypeData = localStorage?.getItem("serviceType");
  const [sendEmail, setSendEmail] = useState(false);
  const [shouldRestoreState, setShouldRestoreState] = useState(false);
  const deleteTriggeredRef = useRef(false);

  const defaultData = {
    page: 1,
    pageSize: PAGE_SIZE,
    statusIds: "",
    compnayName: "",
    search: "",
    isSendMail: false,
  };

  const contacts = useSelector((state) => state.contactList);
  const contact = useSelector((state) => state.contact);

  const getContactListData = (data) => {
    if (data?.isSendMail) {
      setSendEmail(true);
    } else {
      setSendEmail(false);
    }
    dispatch(contactsAction.getContactList(data));
    dispatch(contactsAction.getContactsFilterObj(data));
  };
  const isLoading = useSelector(
    (state) => state.contactList?.isLoading || state.deleteContacts?.isLoading
  );
  const deleteContacts = useSelector((state) => state.deleteContacts);
  const [clickVerifyBtn, setClickVerifyBtn] = useState(false);
  const [accessUserId, setAccessUserId] = useState([]);
  const sendBulkEmailVerificationData = useSelector(
    (state) => state.sendBulkEmailVerification
  );
  const sendBulkEmailVerificationDataIsLoading = useSelector(
    (state) => state.sendBulkEmailVerification?.isLoading
  );

  useEffect(() => {
    const previousRoute = getPreviousRoute();
    const preserveRoutes = [ADMIN_VIEW_CONTACT, ADMIN_EDIT_CONTACT];
    const isFromPreserveRoute =
      previousRoute &&
      preserveRoutes.some((r) => previousRoute.startsWith(r)) &&
      sessionStorage.getItem("contactListPreserveState") === "true";
    sessionStorage.removeItem("contactListPreserveState");

    if (isFromPreserveRoute && contacts?.filterObj) {
      setShouldRestoreState(true);
      getContactListData(contacts.filterObj);
    } else {
      setShouldRestoreState(false);
      getContactListData(defaultData);
    }
    dispatch(userAction.ClearSendBulkEmailVerification());
    setAccessUserId([]);
  }, []);

  const addContact = () => {
    if (InactiveClient()) return;
    navigate(ADMIN_ADD_CONTACTS);
  };
  const handleDeleteOnClick = (contactId) => {
    if (InactiveClient()) return;
    deleteTriggeredRef.current = true;
    dispatch(contactsAction.deleteContacts(contactId));
  };

  const handleEditOnClick = (contactId, statusId) => {
    if (InactiveClient()) return;
    sessionStorage.setItem("contactListPreserveState", "true");
    navigate(ADMIN_EDIT_CONTACT, {
      state: { contactId: contactId, statusId, editMode: true },
    });
  };

  const handleViewOnClick = (contactId) => {
    sessionStorage.setItem("contactListPreserveState", "true");
    navigate(ADMIN_VIEW_CONTACT, {
      state: { contactId: contactId },
    });
  };

  useEffect(() => {
    if (deleteContacts?.status === API_STATUS.SUCCESS && deleteTriggeredRef.current) {
      deleteTriggeredRef.current = false;
      const currentFilter = contacts?.filterObj || defaultData;
      getContactListData(currentFilter);
    }
  }, [deleteContacts]);

  useEffect(() => {
    if (contacts?.status === API_STATUS.SUCCESS && sendEmail) {
      toast("Contacts has been sent to registered email ID");
    }
  }, [contacts]);

  useEffect(() => {
    if (sendBulkEmailVerificationData?.status === "SUCCESS" && clickVerifyBtn) {
      setAccessUserId([]);
      setClickVerifyBtn(false);
      toast("Verification email sent successfully.");
      setTimeout(() => {
        window.location.reload();
      }, 3800);
    }
  }, [sendBulkEmailVerificationData]);

  const sendBulkEmailVarifation = (payload) => {
    dispatch(userAction.postSendBulkEmailVerification(payload));
  };

  return (
    <>
      {sendBulkEmailVerificationDataIsLoading && <Loader />}
      {checkPrivileges([40, 41, 42, 12]) ? (
        <>
          <ToastContainer />
          <ContactList
            contacts={isLoading ? [] : contacts?.data}
            getContactListData={getContactListData}
            isLoading={isLoading}
            addContact={addContact}
            handleDeleteOnClick={handleDeleteOnClick}
            handleViewOnClick={handleViewOnClick}
            handleEditOnClick={handleEditOnClick}
            selectedServiceTypeData={selectedServiceTypeData}
            sendBulkEmailVarifation={sendBulkEmailVarifation}
            setClickVerifyBtn={setClickVerifyBtn}
            setAccessUserId={setAccessUserId}
            accessUserId={accessUserId}
            contact={contacts}
            shouldRestoreState={shouldRestoreState}
          />
        </>
      ) : (
        navigate(ACCESS_DENIED)
      )}
    </>
  );
}
